import { getSearchHistory, removeFromSearchHistory } from './../helpers'
import { SVG_CLOSE_FILLED, SVG_HISTORY_FILLED } from '@getgo/chameleon-icons'
import { html, property } from 'lit-element'
import { nothing } from 'lit-html'
import { repeat } from 'lit-html/directives/repeat'
import { ShellElement } from '../../../common/shell-element'
import searchHistory from './search-history.styles.scss'
import { t } from '../../../directives/translate'
import type { GlobalSearchQueryUI } from '../global-search-models'
import { executeSearch } from '../namespace'
import { unsafeSVG } from 'lit-html/directives/unsafe-svg'

export interface SearchHistoryProps {
  readonly searchHistory: readonly GlobalSearchQueryUI[]
}
export class SearchHistory extends ShellElement implements SearchHistoryProps {
  static readonly tagName = 'goto-search-history'

  @property({ type: Array }) searchHistory: readonly GlobalSearchQueryUI[] = []

  static get styles() {
    return searchHistory
  }

  private async handleClick(event: MouseEvent, query: GlobalSearchQueryUI) {
    event.stopPropagation()
    event.preventDefault()
    await removeFromSearchHistory(query)
    this.searchHistory = await getSearchHistory()
  }

  private handleSearchHistoryItemClick(query: GlobalSearchQueryUI) {
    executeSearch(query)
  }

  private renderSearchQueryItem(query: GlobalSearchQueryUI) {
    return html` <chameleon-menu-item
      size="large"
      @click=${() => this.handleSearchHistoryItemClick(query)}
      class="search-history-item"
      >${query.query}<chameleon-svg slot="start">${unsafeSVG(SVG_HISTORY_FILLED)}</chameleon-svg
      ><chameleon-icon-button
        size="small"
        slot="end"
        variant="neutral"
        class="clear-search-history-item"
        @click="${(event: MouseEvent) => {
          this.handleClick(event, query)
        }}"
      >
        <chameleon-svg>${unsafeSVG(SVG_CLOSE_FILLED)}</chameleon-svg></chameleon-icon-button
      ></chameleon-menu-item
    >`
  }

  render() {
    return html`${this.searchHistory?.length
      ? html`<chameleon-typography
            class="recent-searches-header"
            variant="caption-small-strong"
            color="type-color-secondary"
            >${t('Recent searches')}</chameleon-typography
          >
          <chameleon-menu class="search-history"
            >${repeat(
              this.searchHistory.slice(0, 5),
              searchQuery => searchQuery,
              searchQuery => this.renderSearchQueryItem(searchQuery),
            )}</chameleon-menu
          >`
      : nothing}`
  }
}

declare global {
  interface HTMLElementTagNameMap {
    readonly [SearchHistory.tagName]: SearchHistory
  }
}
